import { Component, input } from '@angular/core';
import { OrderSummaryItem } from 'src/app/models/order-summary';

@Component({
  selector: 'app-order-summary-sidebar',
  templateUrl: './order-summary-sidebar.component.html',
  styleUrls: ['./order-summary-sidebar.component.css'],
})
export class OrderSummarySidebarComponent {
  readonly title = input('Resumen del pedido');
  readonly items = input<readonly OrderSummaryItem[]>([]);
}

